import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "page-settings"
};
const _hoisted_2 = {
  class: "first-title"
};
const _hoisted_3 = {
  key: 5,
  class: "announcement-refresh-option"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_checkbox = _resolveComponent("el-checkbox");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_form = _resolveComponent("el-form");
  const _component_FloatingSaveButton = _resolveComponent("FloatingSaveButton");
  const _directive_loading = _resolveDirective("loading");
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.groupedSettings, (categoryGroup, categoryName) => {
    return _openBlock(), _createElementBlock("div", {
      key: categoryName,
      class: "first-settings"
    }, [_createElementVNode("h3", _hoisted_2, _toDisplayString(categoryName), 1), _createVNode(_component_el_form, {
      model: $data.settings,
      "label-width": "150px"
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryGroup, (setting, index) => {
        return _openBlock(), _createBlock(_component_el_form_item, {
          key: setting.id,
          class: _normalizeClass({
            'announcement-manual-height': setting.id === 'announcement' && $data.announcementManualHeight !== null
          }),
          style: _normalizeStyle(setting.id === 'announcement' && $data.announcementManualHeight !== null ? {
            '--announcement-manual-height': `${$data.announcementManualHeight}px`
          } : undefined)
        }, {
          label: _withCtx(() => [_createTextVNode(_toDisplayString($options.localized(setting, 'label')) + " ", 1), setting.tooltip ? (_openBlock(), _createBlock(_component_el_tooltip, {
            key: 0,
            content: $options.localized(setting, 'tooltip'),
            placement: "top",
            "raw-content": ""
          }, {
            default: _withCtx(() => [_createVNode(_component_font_awesome_icon, {
              icon: "question-circle",
              style: {
                "margin-left": "5px",
                "cursor": "pointer"
              }
            })]),
            _: 1
          }, 8, ["content"])) : _createCommentVNode("", true)]),
          default: _withCtx(() => [setting.type === 'select' ? (_openBlock(), _createBlock(_component_el_select, {
            key: 0,
            modelValue: setting.value,
            "onUpdate:modelValue": $event => setting.value = $event,
            disabled: setting.fixed,
            placeholder: $options.localized(setting, 'placeholder'),
            style: {
              "width": "100%"
            }
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(setting.options, option => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: option.value,
                label: $options.localizedOption(option),
                value: option.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue", "disabled", "placeholder"])) : setting.type === 'channelName' ? (_openBlock(), _createBlock(_component_el_select, {
            key: 1,
            modelValue: setting.value,
            "onUpdate:modelValue": $event => setting.value = $event,
            disabled: !$options.currentUploadChannel || $options.currentChannelList.length === 0,
            placeholder: _ctx.$t('sysPage.channelSelectPlaceholder'),
            clearable: "",
            style: {
              "width": "100%"
            }
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.currentChannelList, ch => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: ch.name,
                label: ch.name,
                value: ch.name
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue", "onUpdate:modelValue", "disabled", "placeholder"])) : setting.type === 'boolean' ? (_openBlock(), _createBlock(_component_el_switch, {
            key: 2,
            modelValue: setting.value,
            "onUpdate:modelValue": $event => setting.value = $event,
            disabled: setting.fixed
          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])) : setting.type === 'textarea' ? (_openBlock(), _createBlock(_component_el_input, {
            key: 3,
            modelValue: setting.value,
            "onUpdate:modelValue": $event => setting.value = $event,
            type: "textarea",
            autosize: {
              minRows: 2,
              maxRows: setting.id === 'announcement' ? 8 : undefined
            },
            resize: "vertical",
            disabled: setting.fixed,
            placeholder: $options.localized(setting, 'placeholder'),
            onMousedown: $event => $options.handleAnnouncementResizeStart($event, setting)
          }, null, 8, ["modelValue", "onUpdate:modelValue", "autosize", "disabled", "placeholder", "onMousedown"])) : (_openBlock(), _createBlock(_component_el_input, {
            key: 4,
            modelValue: setting.value,
            "onUpdate:modelValue": $event => setting.value = $event,
            disabled: setting.fixed,
            placeholder: $options.localized(setting, 'placeholder')
          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "placeholder"])), setting.id === 'announcement' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_checkbox, {
            modelValue: $data.refreshAnnouncement,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.refreshAnnouncement = $event)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sysPage.refreshAnnouncement')), 1)]),
            _: 1
          }, 8, ["modelValue"])])) : _createCommentVNode("", true)]),
          _: 2
        }, 1032, ["class", "style"]);
      }), 128))]),
      _: 2
    }, 1032, ["model"])]);
  }), 128)), _createVNode(_component_FloatingSaveButton, {
    show: !$data.loading,
    onClick: $options.saveSettings
  }, null, 8, ["show", "onClick"])])), [[_directive_loading, $data.loading]]);
}